import request from '@/utils/request'

let PostageApi = {

  /*邮费设置列表*/
  list(data) {
    return request._post('/shop/plus.postage.Index/index', data);
},
/*添加邮费设置*/
add(data) {
    return request._post('/shop/plus.postage.Index/add', data);
},
/*修改邮费设置*/
edit(data) {
    return request._post('/shop/plus.postage.Index/edit', data);
},
/*删除邮费设置*/
del(data) {
    return request._post('/shop/plus.postage.Index/del', data);
},
/*邮费设置详情*/
detail(data) {
  return request._post('/shop/plus.postage.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.postage.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.postage.Setting/getSetting', data, errorback);
    },
}
export default PostageApi;



// WEBPACK FOOTER //
// ./src/api/postage.js